(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-logo-row"] && !Shopify.designMode) return;
  try {
    
  if (!window.kbPressLogoDragBound) {
    window.kbPressLogoDragBound = true;
    let dragState = null;

    document.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !(event.target instanceof Element)) return;
      const scroller = event.target.closest('.press-logo-row__track');
      if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 1) return;
      dragState = { scroller: scroller, startX: event.clientX, startScroll: scroller.scrollLeft, pointerId: event.pointerId, moved: false };
    });

    document.addEventListener('pointermove', function (event) {
      if (!dragState || event.pointerId !== dragState.pointerId) return;
      const distance = event.clientX - dragState.startX;
      if (Math.abs(distance) > 4) {
        dragState.moved = true;
        dragState.scroller.classList.add('is-dragging');
      }
      if (!dragState.moved) return;
      event.preventDefault();
      dragState.scroller.scrollLeft = dragState.startScroll - distance;
    }, { passive: false });

    function stopDragging(event) {
      if (!dragState || (event && event.pointerId !== dragState.pointerId)) return;
      dragState.scroller.classList.remove('is-dragging');
      dragState = null;
    }

    document.addEventListener('pointerup', stopDragging);
    document.addEventListener('pointercancel', stopDragging);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleeping-positions-video"] && !Shopify.designMode) return;
  try {
    
  if (!window.kbSleepingPositionsVideoDragBound) {
    window.kbSleepingPositionsDragBound = true;
    let dragState = null;

    document.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !(event.target instanceof Element)) return;

      const scroller = event.target.closest('.sleeping-positions-video__grid');
      if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 1) return;

      dragState = { scroller: scroller, startX: event.clientX, startScroll: scroller.scrollLeft, pointerId: event.pointerId, moved: false };
    });

    document.addEventListener('pointermove', function (event) {
      if (!dragState || event.pointerId !== dragState.pointerId) return;

      const distance = event.clientX - dragState.startX;
      if (Math.abs(distance) > 4) {
        dragState.moved = true;
        dragState.scroller.classList.add('is-dragging');
      }
      if (!dragState.moved) return;

      event.preventDefault();
      dragState.scroller.scrollLeft = dragState.startScroll - distance;
    }, { passive: false });

    function stopDragging(event) {
      if (!dragState || (event && event.pointerId !== dragState.pointerId)) return;
      dragState.scroller.classList.remove('is-dragging');
      dragState = null;
    }

    document.addEventListener('pointerup', stopDragging);
    document.addEventListener('pointercancel', stopDragging);
  }
    document.addEventListener('contextmenu', function (event) {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.sleeping-positions-video__video')) event.preventDefault();
    });
    document.addEventListener('dragstart', function (event) {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.sleeping-positions-video__video')) event.preventDefault();
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleeping-positions"] && !Shopify.designMode) return;
  try {
    
  if (!window.kbSleepingPositionsDragBound) {
    window.kbSleepingPositionsDragBound = true;
    let dragState = null;

    document.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !(event.target instanceof Element)) return;

      const scroller = event.target.closest('.sleeping-positions__grid');
      if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 1) return;

      dragState = { scroller: scroller, startX: event.clientX, startScroll: scroller.scrollLeft, pointerId: event.pointerId, moved: false };
    });

    document.addEventListener('pointermove', function (event) {
      if (!dragState || event.pointerId !== dragState.pointerId) return;

      const distance = event.clientX - dragState.startX;
      if (Math.abs(distance) > 4) {
        dragState.moved = true;
        dragState.scroller.classList.add('is-dragging');
      }
      if (!dragState.moved) return;

      event.preventDefault();
      dragState.scroller.scrollLeft = dragState.startScroll - distance;
    }, { passive: false });

    function stopDragging(event) {
      if (!dragState || (event && event.pointerId !== dragState.pointerId)) return;
      dragState.scroller.classList.remove('is-dragging');
      dragState = null;
    }

    document.addEventListener('pointerup', stopDragging);
    document.addEventListener('pointercancel', stopDragging);
  }

  } catch(e) { console.error(e); }
})();
})();
